@if (buildings$ | async; as buildings) {
    <div class="ms-auto mb-3" style="max-width: 30rem">
        <form [formGroup]="formGroup">
            <app-input-text-group
                formControlName="search"
                [placeholder]="'placeholders_searchSystems' | translate: 'online' : 'systems'">
            </app-input-text-group>
        </form>
    </div>

    <div class="table-responsive">
        <table
            class="table table-striped mb-0"
            [ngClass]="{'table-sm': buildings.length > 20, 'table-hover': buildings.length > 0}">
            <thead>
                <tr>
                    <th
                        app-sortable-table-header
                        [column]="'buildingName'"
                        (sort)="onSort($event)"
                        [label]="'common_system_name' | translate: 'online' : 'common'"></th>
                    <th
                        app-sortable-table-header
                        [column]="'address'"
                        (sort)="onSort($event)"
                        [label]="'common_ADDRESS' | translate: 'online' : 'common'"></th>
                    <th
                        app-sortable-table-header
                        [column]="'buildingNo'"
                        (sort)="onSort($event)"
                        [label]="'common_BUILDINGNO' | translate: 'online' : 'common'"></th>
                    <th
                        app-sortable-table-header
                        [column]="'buildingIdPairs'"
                        (sort)="onSort($event)"
                        [label]="'properties_proBra' | translate: 'online' : 'systems'"></th>
                </tr>
            </thead>
            <tbody>
                @for (system of buildings; track system) {
                    <tr (click)="selectBuilding(system.building.buildingNo)">
                        <td>
                            {{ system.building.buildingName }}
                        </td>
                        <td>
                            {{ system.address }}
                        </td>
                        <td>
                            {{ system.building.buildingNo }}
                        </td>
                        <td class="text-nowrap">
                            @if (system.buildingIdPairs != null) {
                                @for (
                                    buildingPair of system.buildingIdPairs.slice(0, 5);
                                    track buildingPair
                                ) {
                                    {{ buildingPair }}
                                    @if (!$last) {
                                        ,
                                    }
                                    @if ($last && system.buildingIdPairs.length > 5) {
                                        <button
                                            type="button"
                                            (click)="$event.stopPropagation()"
                                            class="btn btn-link text-lowercase p-0 m-0"
                                            placement="auto"
                                            [autoClose]="'outside'"
                                            popoverClass="custom-popover"
                                            [container]="'body'"
                                            [ngbPopover]="
                                                system.buildingIdPairs.slice(0, 100).join(', ') +
                                                (system.buildingIdPairs.length > 100
                                                    ? '&hellip;'
                                                    : '')
                                            ">
                                            {{ 'actions_showAll' | translate: 'online' : 'common' }}
                                        </button>
                                    }
                                }
                            }
                        </td>
                    </tr>
                } @empty {
                    <tr>
                        <td colspan="4">
                            {{ 'table_noResults' | translate: 'online' : 'common' }}
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
} @else {
    <app-load />
}
